export const MASTER_ROSTER_FETCHING = 'MASTER_ROSTER_FETCHING';
export const MASTER_ROSTER_FETCH_ERROR = 'MASTER_ROSTER_FETCH_ERROR';
export const MASTER_ROSTER_GET_DATA = 'MASTER_ROSTER_GET_DATA';
export const MASTER_ROSTER_GET_REPORT = 'MASTER_ROSTER_GET_REPORT';
export const MASTER_ROSTER_CLEAR_REPORT = 'MASTER_ROSTER_CLEAR_REPORT';
export const MASTER_ROSTER_GET_EXCEL_REPORT = 'MASTER_ROSTER_GET_EXCEL_REPORT';
export const MASTER_ROSTER_CLEAR_EXCEL_REPORT =
  'MASTER_ROSTER_CLEAR_EXCEL_REPORT';



// WEBPACK FOOTER //
// ./src/pages/masterroster/state/masterroster/types.js